'use client';

import dynamic from 'next/dynamic';
import clsx from 'clsx';
import type { CalculatorSectionProps } from './types';
import { resolveCalculatorHiddenFields } from './resolveCalculatorHiddenFields';

const calculatorVariantMap = {
  budgetrechner: dynamic(
    () => import('@/components/user-calculators/budget-calculator'),
    { ssr: false },
  ),
  sparrechner: dynamic(
    () => import('@/components/user-calculators/savings-calculator'),
    { ssr: false },
  ),
  'wohnen-and-tragbarkeit': dynamic(
    () => import('@/components/user-calculators/wohnen-tragbarkeit'),
    { ssr: false },
  ),
} as const;

export default function CalculatorSection({
  calculator,
  utmParameter,
  hiddenFields,
  sectionId,
  spacingTop,
  spacingBottom,
  locale,
}: CalculatorSectionProps) {
  const resolvedHiddenFields = resolveCalculatorHiddenFields(
    utmParameter,
    hiddenFields,
  );

  const CalculatorComponent =
    calculatorVariantMap[calculator as keyof typeof calculatorVariantMap];

  if (!CalculatorComponent) {
    return null;
  }

  return (
    <section
      id={sectionId ?? undefined}
      className={clsx('container mx-auto w-full px-4 sm:px-0', {
        'pt-4 md:pt-8 lg:pt-10': spacingTop,
        'pb-4 md:pb-8 lg:pb-20': spacingBottom,
        'py-4 md:py-8 lg:py-10': !spacingTop && !spacingBottom,
      })}
    >
      <CalculatorComponent
        locale={locale}
        hiddenFields={resolvedHiddenFields}
      />
    </section>
  );
}
